import { useMutation } from "react-relay";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { type createCourseLearnableButton_AcademiesCreateBranchRootMutation } from "@relay/createCourseLearnableButton_AcademiesCreateBranchRootMutation.graphql";
import { CREATE_MUTATION } from "./create-course-learnable-button.graphql";
import { type CreateCourseLearnableButtonProps } from "./create-course-learnable-button.types";
import { Button } from "../../../../components/button";
import { Paths } from "../../../../routes/paths";

export const CreateCourseLearnableButton = ({ ...props }: CreateCourseLearnableButtonProps) => {
	const { t } = useTranslation("common");
	const [create] =
		useMutation<createCourseLearnableButton_AcademiesCreateBranchRootMutation>(CREATE_MUTATION);
	const navigate = useNavigate();
	// const { connectionId } = useContext(OffersScreenContext);

	const handleOnClick = () => {
		create({
			variables: {
				input: {
					title: "UnpublishedCourseLearnable",
				},
				// connections: [connectionId],
			},
			onCompleted: (response) => {
				navigate(
					Paths.educationalOffer.withId(
						response.Admin.Tree.createBranchRoot?.createdRootNode?.node?.id ?? "",
					).path,
				);
				toast.success(t("offers.created"));
			},
			onError: () => {
				toast.error(t("offers.createError"));
			},
		});
	};

	return <Button onClick={handleOnClick} label={t("offers.create")} {...props} />;
};
